import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Box, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect, useState } from "react";

import "./header.css";

export default function Header() {
  const [isClicked, setIsClicked] = useState(null);
  const [close, setClose] = useState(false);

  const handleAnimationEnd = () => {
    if (close)
      setIsClicked(false);
  }

  return (
    <Box className="header-container">
      <Typography className="logo logo-title" variant="h4">
        Port
      </Typography>
      <Box className="header-toggle-container" data-click={(!!isClicked).toString()} data-close-animation={close.toString()} onAnimationEnd={handleAnimationEnd}>
        <Box
          component={"a"}
          href="#home"
          className="no-underline"
          onClick={() => setIsClicked(false)}
        >
          <Typography
            style={{ "--i": 5 }}
            variant="h6"
            className="nav-links link"
          >
            Home
          </Typography>
        </Box>
        <Box
          component={"a"}
          href="#about"
          className="no-underline"
          onClick={() => setIsClicked(false)}
        >
          <Typography
            className="nav-links link"
            style={{ "--i": 6 }}
            variant="h6"
          >
            About
          </Typography>
        </Box>
        <Box
          component={"a"}
          href="#services"
          className="no-underline"
          onClick={() => setIsClicked(false)}
        >
          <Typography
            className="nav-links link"
            style={{ "--i": 7 }}
            variant="h6"
          >
            Services
          </Typography>
        </Box>
        <Box
          component={"a"}
          href="#skills"
          className="no-underline"
          onClick={() => setIsClicked(false)}
        >
          <Typography
            className="nav-links link"
            style={{ "--i": 8 }}
            variant="h6"
          >
            Skills
          </Typography>
        </Box>
        <Box
          component={"a"}
          href="#projects"
          className="no-underline"
          onClick={() => setIsClicked(false)}
        >
          <Typography
            className="nav-links link"
            style={{ "--i": 9 }}
            variant="h6"
          >
            Projects
          </Typography>
        </Box>
        <Box
          component={"a"}
          href="#contact"
          className="no-underline"
          onClick={() => setIsClicked(false)}
        >
          <Typography
            className="nav-links link"
            style={{ "--i": 10 }}
            variant="h6"
          >
            Contact
          </Typography>
        </Box>
      </Box>
      <Box className="mobile_header_bar">
        {isClicked ? (
          <MenuOpenIcon
            className="icon"
            onClick={() => setClose(true)}
          />
        ) : (
          <MenuIcon className="icon" onClick={() => {
            setIsClicked(!isClicked);
            setClose(false)
          }} />
        )}
      </Box>
    </Box>
  );
}
